export default function (value) {
  if (value === undefined || value === null || value === '') {
    return false;
  }

  return !! String(value).trim().length;
}



// WEBPACK FOOTER //
// ./src/validator/required.js